<ng-template #footerTemplate>
    <ng-content></ng-content>
</ng-template>